<div class="checkout-synergy-banner-wrapper">
  <figure class="image cover-image checkout-synergy-banner-image">
    <ng-content select="img"></ng-content>
  </figure>
  <div class="checkout-synergy-banner-content ods-typography-body-s-regular">
    <ng-content></ng-content>
  </div>
</div>
